<div class="topbar" [class.topbar--fullscreen]="isFullscreen">
  <ng-content></ng-content>
  <qr-button
    *ngIf="isCloseButtonVisible"
    class="topbar__btn-close"
    [config]="buttonClose"
    matTooltip="Cerrar"
    (click)="close.emit()"
  ></qr-button>
</div>
